import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const ContributionPart = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>Contributions</Paragraph>
        <Text className='BaseText'>Aptamers are a better way to detect different types of molecules instead of using antibodies. They can have higher affinity than antibodies, good chemical stability, cheaper production and can be engineered completely in a test tube, which gives an easy detection of the target molecules. For this reason we implement this system of detection in our project and wanted to share in the iGEM community the sequences to detect the four biomarkers involved in our project: TNF-α, CXCL9, IL-10 and CRP.<br/><br/>We believe that this contribution to the registry and to the iGEM community will help to increase the database of aptamers and to encourage the research involved with aptamers for future iGEM projects.</Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default ContributionPart;
